export const base = '/wp-json/wp/v2/';
export const posts = "/wp-json/wp/v2/posts/";
export const media = "/wp-json/wp/v2/media/";
export const cases = "/wp-json/wp/v2/nhs-cases/";
export const employees = "/wp-json/wp/v2/nhs-employees/";
export const categories = "/wp-json/wp/v2/categories/";
